import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import messages from '../messages';
import style from '../style.module.less';

export const AmazonDisconnectedContent = () => (
  <BannerMessageV2
    content={
      <>
        <div className={style['amazon-reconnect-title']}>
          <FormattedMessage {...messages.reconnectViaSantosTest} />
        </div>
        <FormattedMessage {...messages.reconnectToSantosTestInstructions} />
      </>
    }
    status={BannerStatus.Info}
  />
);
